import { formatSizeSpaced } from '../utils/formatSize';

// Caption line of a full-screen product: the price of its main variation first, bigger, then the size ("90 ₴ · 10 g").
const FeedCaptionMeta = ({ variation }) => (
  <span className="feed-caption__meta">
    <span className="feed-caption__price">{variation.price} ₴</span>
    {variation.size && <> · {formatSizeSpaced(variation.size)}</>}
  </span>
);

export default FeedCaptionMeta;
